import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ErrorShowService } from '../services/error-show.service';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
  registrationForm: FormGroup;
  submitted = false;
  loading: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router, 
    private loginService: LoginService,
    private errorShowService: ErrorShowService
  ) {
  }

  ngOnInit() {
    this.registrationForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  get f() {
    return this.registrationForm.controls;
  }

 
  onSubmit() {
    this.submitted = true;
    if (this.registrationForm.invalid) {
    } else {
      this.loading = true;
      this.loginService.registerService(this.registrationForm.value).subscribe({
        next: (res) => {
          this.registrationForm.reset();
          this.submitted = false;
          this.loading = false;
          this.errorShowService.showSucess(res['MESSAGE']);
          
        },
        error: (err) => {
          this.errorShowService.showError(err['MESSAGE']);
          this.loading = false;
          this.submitted = false;
        },
      });
    }
  }
  login() {
    this.router.navigateByUrl("/login")
  }
}

